import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../access/auth.service";
import { CategoryV2Dto, ChildCategoryDto, ParentCategoryDto } from "../../models/category.v2";
import { CategoryV2Service } from "../../pages/members/category-v2/services/category.v2.service";
import { CategoryChildDto } from "../../models/category.v3";
import { FeatureFlagService } from "../../util/feature-flag.service";

@Component({
    selector: 'app-category-tree-v2',
    templateUrl: './category-tree.v2.component.html',
    styleUrls: ['./category-tree.v2.component.scss']
})
export class CategoryTreeV2Component {
  @Input() list?: (ParentCategoryDto | ChildCategoryDto | CategoryChildDto)[];
  @Input() category: CategoryV2Dto = new CategoryV2Dto;
    @Input() level: number = 1;

    @Output() addCategoryEvent: EventEmitter<any> = new EventEmitter();
    @Output() editCategoryEvent: EventEmitter<any> = new EventEmitter();
    @Output() deleteCategoryEvent: EventEmitter<any> = new EventEmitter();

    expandedMap: { [id: string]: boolean } = {};
    childrenMap: { [id: string]: ParentCategoryDto[] } = {};
    isV2 = false;
    storeId!: string;

    constructor(
        private _service: CategoryV2Service,
        private _auth: AuthService,
        private _featureFlag: FeatureFlagService,
        private router: Router
    ) { 
      this.storeId = this._auth.getUser().storeId;

    }

    ngOnInit() {
      this.isV2 = this._featureFlag.isV2Store(this.storeId);

        this._service.get(this._auth.getStore().storeId, this.category.id).subscribe({
            next: (res) => {
              this.category = res;
            }
          });
    }
    viewSpecs(categoryId: string): void {
      this.router.navigate(['/members/specifications/listSpecifications'], {
        queryParams: { categoryId }
      });
    }
    
    getSubs(category: ParentCategoryDto | ChildCategoryDto | CategoryChildDto): void {
        const isExpanded = this.expandedMap[category.id];
    
        if (isExpanded) {
          this.expandedMap[category.id] = false; 
        } else {
          this.expandedMap[category.id] = true; 
    
          if (!this.childrenMap[category.id]) {
            this._service.get(this._auth.getStore().storeId, category.id).subscribe({
              next: (res) => {
                this.childrenMap[category.id] = res.children;
              }
            });
          }
        }
      }

getName(item: ParentCategoryDto | ChildCategoryDto | CategoryChildDto): string {
  if (this.isV2) return (item as ParentCategoryDto | ChildCategoryDto).fullName || '';
  return (item as CategoryChildDto).name || '';
}

getStatus(item: ParentCategoryDto | ChildCategoryDto | CategoryChildDto): string {
  if (this.isV2) return (item as ParentCategoryDto | ChildCategoryDto).status || '';
  return (item as CategoryChildDto).status || 'ACTIVE';
}

addCategory(item: any) {
  this.addCategoryEvent.emit(item);
}

editCategory(item: any) {
  this.editCategoryEvent.emit(item);
}

deleteCategory(item: any) {
  this.deleteCategoryEvent.emit(item);
}

    
}